import React, { PropsWithChildren } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dimmer, Loader } from 'semantic-ui-react';
import { ApplicationState } from '../..';

const connector = connect(
    (state: ApplicationState) => state.core
)
type PropsFromRedux = ConnectedProps<typeof connector>

type StateProps = PropsWithChildren<PropsFromRedux>

class AjaxLoader extends React.Component<StateProps> {
    render() {
        return (
            <div>
                <Dimmer active={this.props.ajaxCallsInProgress > 0} inverted>
                    <Loader size="large">Caricamento...</Loader>
                </Dimmer>
                {this.props.children}
            </div>
        );
    }
};

export default connector(AjaxLoader);

/*
export default connect(
    state => state.application
)(AjaxLoader);
*/